import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import dayjs from "dayjs";

import { Button } from "../../elements/Button";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import { ReactComponent as PlusPrimary } from "../../assets/icons/primary_plus.svg";
import CreateEditEntryModal from "./CreateEditEntryModal";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_red.svg";
import {
  deleteManualAdjustmentApiHandler,
  getAllConsolManualAdjustmentsApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";

const ManualAdjustments = ({ history, consolID }) => {
  const [manualAdjustments, setManualAdjustments] = useState([]);
  const [entryModal, setEntryModal] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);

  const closeEntryModal = () => {
    setEntryModal(false);
    setSelectedEntry(null);
  };

  useEffect(() => {
    getManualAdjustments();
  }, []);

  const getManualAdjustments = (cat) => {
    const getParams = {
      category: cat,
      consolID: consolID,
    };
    getAllConsolManualAdjustmentsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const manualAdjData = response?.data;

          setManualAdjustments(manualAdjData?.manualAdjustments ?? []);
        } else {
          setManualAdjustments([]);
          swal(
            "Error",
            response?.data?.error || "Unable to get manual adjustments",
            "error"
          );
        }
      })
      .catch((error) => {
        setManualAdjustments([]);
        swal(
          "Error",
          error?.response?.data?.error ||
            "Unable to populate manual adjustments",
          "error"
        );
      });
  };

  const handleDelete = (adjId) => {
    swal({
      title: "Confirm deletion of Adjustment",
      text: "Once deleted, you will not be able to recover this!",
      // icon: "warning",
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "Delete",
          value: true,
          visible: true,
          className: "swal-delete-btn",
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteManualAdjustmentApiHandler({
          consolID: consolID,
          manualAdjustmentID: adjId,
        })
          .then((response) => {
            if (response?.data?.success === true) {
              swal("Adjustment deleted successfully", "", "success");
              getManualAdjustments();
            } else {
              swal(
                "Error",
                response?.data?.error || "Unable to deleted Adjustment",
                "error"
              );
            }
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error || "Unable to deleted Adjustment",
              "error"
            );
          });
      }
    });
  };

  return (
    <>
      <div className={icrCss.header} style={{ justifyContent: "end" }}>
        <Button
          icon={<PlusPrimary />}
          btnColor={buttoncss.greyBg}
          label="Add Entry"
          onClick={() => {
            setSelectedEntry(null);
            setEntryModal(true);
          }}
        />
        <Button
          btnColor={buttoncss.primary}
          label="Populate FS"
          onClick={() => {
            history.push(`/myfinV2/console-populatefs/${consolID}`);
          }}
        />
      </div>

      <div className={icrCss.entrytableCtn} style={{paddingTop: "20px"}}>
        <table className={icrCss.entrytable} STYLE={{ paddingRight: "20px"}}>
          <thead>
            <tr>
             
              <th className="text-left" style={{paddingLeft: "15px"}}>Particulars</th>
               <th className="text-center" style={{ width: "130px" }}>
                Date
              </th>
              <th style={{ textAlign: "right", paddingRight: "25px" }}>Current year</th>
              <th style={{ textAlign: "right", paddingRight: "20px" , whiteSpace: "noWrap"}}>Previous year</th>

              <th className="text-left" style={{ width: "320px", paddingLeft: "70px" }}>
                Remarks
              </th>
              <th className="text-center" style={{ width: "55px"}}></th> 
            </tr>
          </thead>

          <tbody>
            {manualAdjustments.length > 0 &&
              manualAdjustments.map((group, groupIndex) => (
                <React.Fragment key={groupIndex}>
                  {group.adjustments.map((row, rowIndex) => (
                    <tr key={`${groupIndex}-${rowIndex}`}>
                      <td className="text-left" style={{paddingLeft: "15px"}}>{row.levelThree}</td>
                      {rowIndex === 0 && (
                        <td
                          rowSpan={group.adjustments.length}
                          className="text-center"
                        >
                          {group.adjustmentDate
                            ? dayjs(group.adjustmentDate).format("DD-MMM-YYYY")
                            : ""}
                        </td>
                      )}  
                    <td className={icrCss.amount}>{row.currentYear}</td>
                    <td className={icrCss.amount}>{row.previousYear}</td>


                      {rowIndex === 0 && (
                        <td
                          rowSpan={group.adjustments.length}
                          className="text-left"
                          style={{ paddingLeft: "70px" }}
                        >
                          {group.remarks}
                        </td>
                      )}

                      {rowIndex === 0 && (
                        <td
                          rowSpan={group.adjustments.length}
                          className="text-center"
                           style={{ paddingRight: "17px" }}
                        >
                          <div  style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}>

                          <EditIcon
                            height={18}
                            width={18}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedEntry(group);
                              setEntryModal(true);
                            }}
                          />
                          &ensp; &ensp;
                          <DeleteIcon
                            height={18}
                            width={18}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handleDelete(group?._id);
                            }}
                          />
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}

                  <tr className={icrCss.groupSeparator}>
                    <td colSpan={6}></td>
                  </tr>
                </React.Fragment>
              ))}

            {manualAdjustments.length === 0 && (
              <tr>
                <td colSpan={6}>No Adjustment Data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {entryModal && (
        <CreateEditEntryModal
          consolID={consolID}
          handleClose={closeEntryModal}
          editData={selectedEntry}
          getManualAdjustments={getManualAdjustments}
        />
      )}
    </>
  );
};

export default ManualAdjustments;
